import React, { ChangeEvent, forwardRef, Fragment, useRef } from "react";
import { useSelector } from "react-redux";
import classnames from "classnames";

import { Button } from "../button/Button";
import { useIntlTranslate } from "../../hooks";
import { getUploadUrlState } from "../../pages/urlFilters/urlFilters.selectors";

interface UploadFileButtonProps {
  className?: string;
  filetypes: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const UploadFileButton = forwardRef<
  HTMLButtonElement,
  UploadFileButtonProps
>(function UploadFileButton({ className, filetypes, onChange }, ref) {
  const inputRef = useRef<HTMLInputElement>(null);
  const { fileName } = useSelector(getUploadUrlState);
  const translate = useIntlTranslate();

  const file = fileName || translate("aria_no_file_chosen");
  const label = translate("choose_file");

  return (
    <Fragment>
      <Button
        ref={ref}
        size={"large"}
        className={classnames("upload-file-button", className)}
        onClick={() => inputRef.current.click()}
        aria-label={`${file}, ${label}`}
      >
        {label}
      </Button>
      <input
        ref={inputRef}
        type="file"
        accept={filetypes}
        hidden
        value=""
        onChange={onChange}
      />
    </Fragment>
  );
});
